import React, {FC} from 'react';
import styled from 'styled-components';
import {SizeRun} from '../../FilterContent/Size/SizeRun';
import {SizeType} from '../../FilterContent/Size/types';
import {FilterDropdown} from '../FilterDropdown';

interface Props {
  activeSizeIds: Array<string>;
  label: string;
  onSizeClick: (sizeId: string) => void;
  sizes: Array<SizeType>;
  onFilterReset: () => void;
  onOpen?: () => void;
  onClose?: () => void;
}

export const FilterDropdownSizeSimple: FC<Props> = ({
  activeSizeIds,
  label,
  onSizeClick,
  sizes,
  onFilterReset,
  onClose,
  onOpen,
}) => {
  return (
    <FilterDropdown
      dataTestId="filterDropdownSizeSimple"
      activeCount={activeSizeIds.length}
      label={label}
      onReset={onFilterReset}
      onClose={onClose}
      onOpen={onOpen}
      filterContent={
        <StyledSizeRun
          activeSizeIds={activeSizeIds}
          onSizeClick={(sizeId: string) => onSizeClick(sizeId)}
          sizes={sizes}
        />
      }
      showScrollFade
    />
  );
};

const StyledSizeRun = styled(SizeRun)`
  margin: 0;
`;
